const AUTO = {
  name: 'AUTO',
  display: 'Auto',
}
const PROPERTY = {
  name: 'PROPERTY',
  display: 'Property',
}
const EQUIPMENT = {
  name: 'EQUIPMENT',
  display: 'Equipment',
}
const GL = {
  name: 'GL',
  display: 'General Liability',
}
const WORK_COMP = {
  name: 'WORK_COMP',
  display: 'Work Comp',
}
const NO_FAULT = {
  name: 'NO_FAULT',
  display: 'No Fault Form',
}
const IDK = {
  name: 'IDK',
  display: "I don't know",
}
const LPL = {
  name: 'LPL',
  display: 'Legal Professional',
}

// Sets the default order
const DEFAULT_CLAIM_TYPE_OBJECTS = [IDK, AUTO, PROPERTY, EQUIPMENT, GL, WORK_COMP, NO_FAULT]

const DEFAULT_CLAIM_TYPES = DEFAULT_CLAIM_TYPE_OBJECTS.map(ct => ct.name)

export { AUTO, PROPERTY, EQUIPMENT, GL, WORK_COMP, NO_FAULT, IDK, LPL, DEFAULT_CLAIM_TYPES }
